import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV_LINKS } from "../../mocks/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 border-b border-background-200/70 backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-[1200px] items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜17 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
            <i className="ri-megaphone-line" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
            吃瓜<span className="text-primary-600">17</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700 font-semibold"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/news"
            className="ml-2 inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-focus-3-line" aria-hidden="true"></i>
            去围观新瓜
          </Link>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-6 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-3 text-base transition-colors ${
                    isActive ? "bg-primary-100 font-semibold text-primary-700" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/news"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-lg bg-primary-500 px-4 py-3 text-base font-semibold whitespace-nowrap text-background-50"
            >
              <i className="ri-focus-3-line" aria-hidden="true"></i>
              去围观新瓜
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}